var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.form
        ? _c("ma-form", {
            attrs: { type: "large", formData: _vm.form },
            on: {
              change: function($event) {
                _vm.handleFormChange($event)
                _vm.handleNestedComponents($event)
              }
            },
            nativeOn: {
              focus: function($event) {
                return _vm.handleInputFocus()
              }
            }
          })
        : _vm._e(),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.addDamageBtnIsHidden,
              expression: "!addDamageBtnIsHidden"
            }
          ],
          staticClass: "btn mainBlue mg mg--t-4",
          attrs: {
            "qa-add-damage-btn": "",
            disabled: _vm.disableAddDamageButton
          },
          on: { click: _vm.handleAddDamage }
        },
        [_vm._v(_vm._s(_vm.$t("actions.addDamage")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }